// eslint-disable-next-line import/no-extraneous-dependencies
import gql from "graphql-tag";

const GET_ORDER_LIST = gql`
  query GET_ORDER_LIST($input: GetListInputV1) {
    getOrderList(input: $input) {
      data {
        count
        orderList {
          _id
          createdAt
          financialStatus
          fulfillmentStatus
          moneyFormat
          orderLines {
            _id
            shopifyLineItemId
            isReturn
            isDelivered
            fulfillmentType
            status
          }
          orderNumber
          status
          totalPrice
          updatedAt
          vendorCount
        }
      }
      status
      error
    }
  }
`;

export default GET_ORDER_LIST;
